import { FC } from 'react';

import { ApprovalStatusEnum } from '../../enum';
import { CoreStatus } from '../CoreStatus';

interface ApprovalStatusProps {
  value: ApprovalStatusEnum;
}

const ApprovalStatusColor = {
  [ApprovalStatusEnum.Approved]: '#22C55E',
  [ApprovalStatusEnum.Pending]: '#D19500',
  [ApprovalStatusEnum.Rejected]: '#D21515',
};
export const ApprovalStatus: FC<ApprovalStatusProps> = ({ value }) => (
  <CoreStatus value={value} backgroundColor={ApprovalStatusColor[value]} />
);
